










































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Size } from '@front-app/components/constants';
import { bytesToSize } from '@front-app/util/bytesToSize';

export default defineComponent({
	components: {
		CtaButton,
		FontAwesomeIcon,
	},
	props: {
		id: {
			type: String,
			required: true,
		},
		value: {
			type: Array as PropType<File[]>,
			default: () => [],
		},
		size: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
		multiple: Boolean,
	},
	setup(props, ctx) {
		const onChange = (e: Event) => {
			const el = e.target as HTMLInputElement;
			if (!el || !el.files) {
				ctx.emit('change', []);
				return;
			}
			ctx.emit('change', Array.from(el.files));
			el.value = '';
		};
		const fileName = computed(() => {
			if (!props.value) {
				return '';
			}
			return props.value
				.map(({ name }) => name)
				.join(', ');
		});
		const selectedFileSize = computed(() => {
			const totalSize = props.value.map(({ size }) => size)
				.reduce((acc, curr) => acc + curr, 0);
			const fs = bytesToSize(totalSize);
			const quantity = ctx.root.$n(fs.quantity, 'short');
			return ctx.root.$t(fs.size, { quantity });
		});
		return {
			onChange,
			fileName,
			selectedFileSize,
		};
	},
});
